import axios from "axios";
import { ProjectIdType } from "../../types/public-types";

const baseUrl = process.env.REACT_APP_BASE_URL;

interface ArtifactType {
    projectId: ProjectIdType;
    artifactName: string;
    artifactDescription: string;
    artifactType: string;
    artifactUrl: string;
    artifactThumbnailUrl: string;
    artifactCreatedAt: Date;
}


export const getArtifacts = async (projectId: ProjectIdType) => {
    const res = await axios.get(`${baseUrl + `artifacts/?projectId=${projectId}`}`);
    return res;
};

export const createArtifact = async (projectId: ProjectIdType, data: {
    artifactName: string;
    artifactType: string;
    artifactDescription: string;
    keywords: string[];
    artifactFileName: string;
}) => {
    const res = await axios.post(`${baseUrl + `artifacts/`}`, {
        projectId,
        artifactName: data.artifactName,
        category: data.artifactType,
        artifactDescription: data.artifactDescription,
        keywords: data.keywords,
        artifactFileName: data.artifactFileName,
    });
    return res;
};

export const getSingleArtifact = async (artifactId: string) => {
    const res = await axios.get(`${baseUrl + `artifacts/signed-url/?artifactId=${artifactId}`}`);
    return res;
};

export const uploadVerifiedArtifact = async (artifactId: string) => {
    const res = await axios.patch(`${baseUrl + `artifacts/upload-verified`}`, {
        artifactId,
        uploadVerified: true,
    });
    return res;
};

export const deleteArtifact = async (artifactId: string) => {
    const res = await axios.delete(`${baseUrl + `artifacts/${artifactId}`}`);
    return res;
};